<template>
    <div>
        <modal-add-dimension ref="addDimensionDialog" :item="this.categoryId"/>
        <modal-add-service-type ref="addServiceDialog" :item="this.categoryId"/>
        <v-container class="grey lighten-5" fluid>
            <v-row v-if="categoryDetails && Object.entries(categoryDetails).length">
                <v-col cols="12">
                    <v-card>
                        <v-card-title>Dane kategorii</v-card-title>
                        <v-card-text>
                            <v-form ref="categoryDetailsForm">
                                <v-row>
                                    <v-col cols="12" sm="12" md="8" lg="6">
                                        <v-text-field
                                            v-model="categoryDetails.name"
                                            class="pt-0"
                                            label="Nazwa"
                                            placeholder=" "
                                            disabled
                                        ></v-text-field>
                                      <v-text-field
                                          v-model="categoryDetails.keywords"
                                          class="pt-0"
                                          label="Słowa kluczowe (wymienione po przecinku)"
                                          placeholder=" "
                                      ></v-text-field>
                                        <v-textarea
                                            v-model="categoryDetails.description"
                                            class="pt-0"
                                            label="Opis"
                                            placeholder=" "
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                      <v-col cols="3" v-for="(image, index) in categoryDetails.images" v-bind:key="image.id">
                                        <v-img v-bind:src="image.url" max-width="200" max-height="200"></v-img>
                                        <v-btn v-on:click="removeImage(image);categoryDetails.images.splice(index, 1)">usuń zdjęcie</v-btn>
                                      </v-col>
                                      <vue-dropzone id="dropzone" :options="dropzoneOptions" class="mt-4"
                                                    v-on:vdropzone-success="storeImageId"
                                                    v-on:vdropzone-removed-file="removeImage"></vue-dropzone>
                                    </v-col>
                                </v-row>
                                <div v-if="categoryDetails.dimensions">
                                    <v-card-title>Wymiary</v-card-title>
                                    <v-btn @click="showAddDimensionModal()">Dodaj wymiar</v-btn>
                                    <v-data-table
                                        :headers="dimensionHeaders"
                                        :items="categoryDetails.dimensions"
                                        v-sortable-data-table
                                        @sorted="saveOrder"
                                        item-key="name"
                                    >
                                        <template v-slot:item.name="{ item }">
                                            <v-col cols="12" sm="12" md="8" lg="6">
                                                <input v-model="item.id" hidden/>
                                                <v-text-field
                                                    append-icon="mdi-delete"
                                                    @click:append="deleteDimension(item.id)"
                                                    v-model="item.name"
                                                    class="pt-0"
                                                    label="Nazwa wymiaru"
                                                    placeholder=" "
                                                ></v-text-field>
                                            </v-col>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                @click="saveCategoryDetails"
                            >
                                Zapisz
                                <v-icon size="24" right>
                                    mdi-content-save-outline
                                </v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="grey lighten-5" fluid>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>Usługi</v-card-title>
                        <v-card-text>
                            <v-btn @click="showAddServiceModal()">Dodaj usługę</v-btn>
                            <v-form class="mt-4" ref="categoryServicesForm">
                                <div v-if="services">
                                    <v-col cols="12" sm="12" md="8" lg="6" v-for="item in services"
                                           v-bind:key="item.id">
                                        <input v-model="item.id" hidden/>
                                        <v-text-field
                                            append-icon="mdi-delete"
                                            @click:append="deleteService(item.id)"
                                            v-model="item.name"
                                            class="pt-0"
                                            label="Nazwa usługi"
                                            placeholder=" "
                                        >
                                            <template v-slot:append-outer>
                                                <v-btn @click="saveService(item.id, item.name)">Zapisz</v-btn>
                                            </template>
                                        </v-text-field>
                                        <router-link :to="{name: 'service-type-details', params: { id: item.id }}">Dodatkowe pola</router-link>
                                    </v-col>
                                </div>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <modal-loader :show="loading"/>
    </div>
</template>

<script>
import api from '../services/api';
import humanFileSize from '../mixins/humanFileSize';
import formatters from "@/mixins/formatters";
import permissions from "@/mixins/permissions";
import ModalLoader from "../components/ModalLoader";
import ModalAddDimension from "../components/ModalAddDimension";
import Sortable from 'sortablejs';
import ModalAddServiceType from "../components/ModalAddServiceType";
import vue2Dropzone from "vue2-dropzone";
import {Auth} from "@/services/Auth";

export default {
    components: {
        ModalAddServiceType,
        ModalLoader,
        ModalAddDimension,
        vueDropzone: vue2Dropzone,
    },
    mixins: [
        formatters,
        humanFileSize,
        permissions,
    ],
    props: ['id'],
    savedCategoryDetails: null,
    data() {
        return {
            dimensionHeaders: [
                {
                    text: 'Nazwa',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
            ],
            loading: false,
            loadingDetails: false,
            loadingServices: false,
            loadingFields: false,

            categoryId: null,
            rawCategoryDetails: [],
            categoryDetails: [],
            services: [],
            dropzoneOptions: {
              url: `${process.env.VUE_APP_API_URL}/api/categories/images`,
              thumbnailWidth: 150,
              maxFilesize: 1024 * 20,
              maxFiles: 10,
              acceptedFiles: 'image/*',
              addRemoveLinks: true,
              headers: {
                'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
              }
            },
        }
    },
    methods: {
        async loadDetails() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;

            let response;

            try {
                response = await api.get(`/api/categories/${this.categoryId}`);
            } catch (error) {
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się wczytać danych kategorii.',
                    error,
                });

                return;
            }

            this.loadingDetails = false;

            this.rawCategoryDetails = response.data;
            let photosIds = this.rawCategoryDetails.images ? this.rawCategoryDetails.images.map(photo => photo.id) : [];
            this.categoryDetails = {
              name: this.rawCategoryDetails.name || null,
              description: this.rawCategoryDetails.description || null,
              keywords: this.rawCategoryDetails.keywords || null,
              dimensions: this.rawCategoryDetails.dimensions || [],
              photosIds: photosIds || [],
              images: this.rawCategoryDetails.images || [],
            };

            this.savedCategoryDetails = JSON.parse(JSON.stringify(this.categoryDetails));
        },
        async loadServices() {
            if (this.loadingServices) {
                return;
            }

            this.loadingServices = true;

            let response;

            try {
                response = await api.get(`/api/categories/${this.categoryId}/service`);
            } catch (error) {
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się wczytać usług.',
                    error,
                });

                return;
            }

            this.loadingServices = false;

            this.services = response.data.services;
        },
        async saveCategoryDetails() {
            if (!this.$refs.categoryDetailsForm.validate()) {
                return;
            }

            // The following variable will contain only those fields that were modified.
            const dataToSave = this.categoryDetails;

            if (!Object.keys(dataToSave).length) {
                this.$root.$emit('notify', {
                    html: 'Nie ma nic nowego do zapisania.'
                });

                return;
            }

            this.loading = true;

            try {
                await api.put(`/api/categories/${this.categoryId}`, dataToSave);
            } catch (error) {
                /** @see https://github.com/axios/axios#handling-errors */
                this.loading = false;
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się zapisać danych kategorii.',
                    error
                });

                return;
            }

            this.loading = false;
            this.$root.$emit('notifySuccess', {
                html: 'Dane kategorii zostały zapisane.'
            });
        },
        async deleteDimension(id) {
            this.loading = true;

            try {
                await api.delete(`/api/categories/${this.categoryId}/dimension/${id}`);
            } catch (error) {
                /** @see https://github.com/axios/axios#handling-errors */
                this.loading = false;
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się usunąć wymiaru.',
                    error
                });

                return;
            }

            await this.loadDetails();
            this.loading = false;
            this.$root.$emit('notifySuccess', {
                html: 'Wymiar został usunięty.'
            });
        },
        async showAddDimensionModal() {
            this.$refs.addDimensionDialog
                .open()
        },
        async showAddServiceModal() {
            this.$refs.addServiceDialog
                .open()
        },

        saveOrder(event) {
            const movedItem = this.categoryDetails.dimensions.splice(event.oldIndex, 1)[0];
            this.categoryDetails.dimensions.splice(event.newIndex, 0, movedItem);
        },

        async saveService(id, name) {
            this.loading = true;

            try {
                await api.put(`/api/categories/${this.categoryId}/service/${id}`, {name: name});
            } catch (error) {
                /** @see https://github.com/axios/axios#handling-errors */
                this.loading = false;
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się zapisać usługi.',
                    error
                });

                return;
            }

            this.loading = false;
            this.$root.$emit('notifySuccess', {
                html: 'Usługa została zaktualizowana.'
            });
        },
        async deleteService(id) {
            this.loading = true;

            try {
                await api.delete(`/api/categories/${this.categoryId}/service/${id}`);
            } catch (error) {
                /** @see https://github.com/axios/axios#handling-errors */
                this.loading = false;
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się usunąć usługi.',
                    error
                });

                return;
            }

            await this.loadServices();
            this.loading = false;
            this.$root.$emit('notifySuccess', {
                html: 'Usługa została usunięta.'
            });
        },
        storeImageId(event, image) {
          this.categoryDetails.photosIds.push(image.id);
        },
        removeImage(image) {
          this.categoryDetails.photosIds = this.categoryDetails.photosIds.filter(photo => photo !== image.id);
          this.categoryDetails.images = this.categoryDetails.images.filter(photo => photo.id !== image.id);
        },
    },
    directives: {
        sortableDataTable: {
            bind(el, binding, vnode) {
                const options = {
                    animation: 150,
                    onUpdate: function (event) {
                        vnode.child.$emit('sorted', event)
                    }
                }
                Sortable.create(el.getElementsByTagName('tbody')[0], options)
            }
        }
    },
    async created() {
        try {
            this.categoryId = this.id; // Store new user id in the local variable.
            await this.loadDetails();
            await this.loadServices();
        } catch (e) {
            void (0);
        }
    },
    beforeRouteUpdate(to, from, next) {
        next(); // Update the URL in address bar.
        this.categoryId = to.params.id; // Store new user id in the local variable.
        this.loadDetails();
    },
}
</script>

<style scoped>
</style>
